module.exports = __webpack_public_path__ + "static/img/csi.81bcbe7c.png";